import { AuthCard } from '@/shared/ui/auth/auth-card';

import { AccountLockedIcon } from './account-locked-card/account-locked-icon';

type Props = {
    email?: string;
};

export function AccountLockedCard({ email }: Props) {
    return (
        <div className="flex flex-1 items-start justify-center px-4">
            <AuthCard size="narrow" className="mt-28">
                <div className="flex flex-col gap-6">
                    <AccountLockedIcon />

                    <div className="flex flex-col gap-2">
                        <h1 className="text-3xl font-bold md:text-4xl">
                            Your account has been locked
                        </h1>
                        <p className="text-lg font-semibold text-foreground">
                            {email
                                ? `We've sent an email with instructions to unlock your account to ${email}`
                                : "We've sent an email with instructions to unlock your account."}
                        </p>
                    </div>

                    <p className="text-sm text-muted-foreground">
                        Didn't receive it? Don't forget to check your spam folder. If no email
                        arrives within 2 minutes, email hello@nessoapp.com
                    </p>
                </div>
            </AuthCard>
        </div>
    );
}
